@if (orderDetails && orderDetails.licenses) {
  <div class="list-container">
    @for (license of expandedOrderDetails; track license; let i = $index) {
      <div>
        <div class="row-wrapper">
          <div class="product-column">
            {{license.productName}}
          </div>
          <div class="all-details-column">
            <mat-icon
              class="clickable-pointer"
              tabindex="0"
              [matTooltip]="license.ratePlanInfo"
              svgIcon="info_icon">
            </mat-icon>
            <div id="{{'proDetails' + i}}"  class="details-column" [matTooltip]="license.tooltip">
              {{license.productDetails}}
            </div>
          </div>
          @if (license.numLicenses == 1) {
            <div class="number-licenses-column">
              {{license.numLicenses}} {{'order_details.license' | translate}}
            </div>
          }
          @if (license.numLicenses != 1) {
            <div class="number-licenses-column">
              {{license.numLicenses}} {{'order_details.licenses' | translate}}
            </div>
          }
        </div>
      </div>
    }
  </div>
}
